export default "__VITE_ASSET__vg$3ah8___"